import { toolbarHeightVar, viewportHeightVar } from '@sales-center/common'
import { Theme } from '@mui/material/styles'

/*
 * Height cascade, widest fallback first: plain `100vh`, then
 * `var(--sc-viewport-height, 100dvh)` behind an `@supports` guard. The guard is
 * required — on a browser without `dvh` the var's own fallback would resolve to
 * invalid CSS and drop the declaration entirely.
 *
 * The var tracks `visualViewport.height` (see `useVisualViewportHeight`) so the
 * shell shrinks with the on-screen keyboard. `100dvh` does not do this, which is
 * what let the keyboard push the fixed toolbar and the sticky Save/Cancel header
 * off-screen on iOS. See WWM-17564.
 */
export const getStyles = (accessDenied: boolean) => ({
  root: {
    minHeight: '100vh',
    backgroundColor: (theme: Theme) => theme.palette.common.white,
    display: 'flex',
    height: !accessDenied ? `calc(100vh - ${toolbarHeightVar} - 1px)` : '100vh',
    minWidth: 0, // ⬅️ was breakpoint-based minWidth
    '@supports (height: 100dvh)': {
      minHeight: viewportHeightVar,
      height: !accessDenied
        ? `calc(${viewportHeightVar} - ${toolbarHeightVar} - 1px)`
        : viewportHeightVar,
    },
  },

  toolbar: {
    height: toolbarHeightVar,
  },

  content: {
    flexGrow: 1,
    minWidth: 0, // ⬅️ also let content shrink
    width: '100%',
    height: !accessDenied ? `calc(100vh - ${toolbarHeightVar})` : '100vh',
    '@supports (height: 100dvh)': {
      height: !accessDenied
        ? `calc(${viewportHeightVar} - ${toolbarHeightVar})`
        : viewportHeightVar,
    },
  },

  body: {
    minHeight: !accessDenied ? `calc(100vh - ${toolbarHeightVar})` : '100vh',
    '@supports (height: 100dvh)': {
      minHeight: !accessDenied
        ? `calc(${viewportHeightVar} - ${toolbarHeightVar})`
        : viewportHeightVar,
    },
  },
})
